var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "background darken-1",
      attrs: {
        value: _vm.visible,
        absolute: "",
        right: "",
        temporary: "",
        "disable-route-watcher": ""
      },
      on: {
        input: function($event) {
          return _vm.close($event)
        }
      }
    },
    [
      _vm.asset
        ? _c(
            "v-card",
            { staticClass: "background elevation-0" },
            [
              _c(
                "v-card-title",
                { staticClass: "pa-2 title" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0 mr-3",
                      attrs: { flat: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.asset.ref_material) +
                      " | " +
                      _vm._s(_vm.asset.id) +
                      "\n\t\t"
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "background darken-1 pa-0" },
                [_c("Asset", { attrs: { asset: _vm.asset } })],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a0bd443", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a0bd443","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/filesystem/title_asset_finder_asset_drawer.vue
// module id = null
// module chunks = 